import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useModalContext } from '../../../context/Modal';
import { useUserStrategies } from '../../../context/UserStrategies';
import { DELETE_STRATEGY_ASSETS } from '../../../http/apollo-queries';
import { FooterNavigator } from '../../Footer/FooterNavigator';

export const DeleteAssetModal = ({
  strategyAssetIds,
  strategyId,
}: {
  strategyAssetIds: string[];
  strategyId: string;
}) => {
  const { t } = useTranslation();
  const { closeModal } = useModalContext();
  const { refetch: refetchStrategies, loading: loadingStrategies } =
    useUserStrategies();

  const [deleteStrategyAssets, { loading: loadingDeleteStrategyAsset }] =
    useMutation(DELETE_STRATEGY_ASSETS);

  const title = t(
    `modals.deleteAsset.title.${strategyAssetIds.length > 1 ? 1 : 0}`
  );
  const subtitle = t('modals.deleteAsset.subtitle');

  const onSave = () => {
    deleteStrategyAssets({
      variables: {
        strategyId,
        strategyAssetIds,
      },
    }).then(() => refetchStrategies().then(() => closeModal()));
  };

  return (
    <div className="flex flex-col gap-3 my-20 dark:bg-grey-90 dark:text-white">
      <div
        className={`
        w-4/5
        mx-auto
        font-medium
        text-center
        text-xl
      `}
      >
        {title}
      </div>

      <div className="text-grey-50 text-center">{subtitle}</div>

      <FooterNavigator
        loading={loadingDeleteStrategyAsset || loadingStrategies}
        saveButtonName="Delete"
        saveButtonVariant={`negative`}
        onCancel={closeModal}
        onSave={onSave}
      />
    </div>
  );
};
